import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.onscroll = function () {
      if (window.scrollY > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
  }, []);

  return (
    <nav className={`navbar ${scrolled && `scrolled`}`}>
      <div className="nav container">
        <div className="logo-wrapper">
          <Link to="/">
            <h3>Swift Tech Pay</h3>
          </Link>
        </div>
        <div className="contact-wrapper">
          <Link to="/contact">
            <h4>Contact Sales</h4>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
